module.exports = __webpack_public_path__ + "img/Speaker=Jay Krishnan.fb3a04a5.png";